import React, {ReactElement} from 'react';
import {classes} from './Totals.st.css';
import {TotalsRow} from './Partials/TotalsRow/TotalsRow';
import {TotalsSection} from './Partials/TotalsSection/TotalsSection';

export enum TotalsDataHook {
  TotalsTable = 'totals-table',
  TotalsRow = 'total-row',
  TotalsRowTitle = 'total-row-title',
  TotalsRowValue = 'total-row-value',
  TotalsRowValueText = 'totals-row-value-text',
  TotalsSection = 'totals-section',
  TotalsSectionTitle = 'totals-section-title',
}

export interface TotalsProps {
  children?: (ReactElement | false)[] | ReactElement | false;
  dataHook?: string;
}

export const Totals = ({children, dataHook}: TotalsProps) => {
  return (
    <div data-hook={dataHook ?? /* istanbul ignore next */ TotalsDataHook.TotalsTable} className={classes.tableWrapper}>
      {children}
    </div>
  );
};

Totals.displayName = 'Totals';
Totals.TotalsRow = TotalsRow;
Totals.TotalsSection = TotalsSection;
